import React from 'react'
import { useDispatch } from 'react-redux'
import { formatCurrenctyWithoutSignal } from 'utils'
import { STORE_CONFIRMATION_TERM_FILE_URL } from 'app-constants'
import { STATICS } from 'statics'
import { clearDrawerModal } from 'slices/drawer'
import { ActionContainer } from '../action-container'
import { CONFIRM_SUBSCRIPTION_STEPS } from '../../constants'
import './style.scss'

export function ConfirmationInfo({ cart, totalValue, isLoading, setCurrentStep }) {
  const isMultipleProducts = cart.length > 1
  const dispatch = useDispatch()

  function handleBackButtonClick() {
    dispatch(clearDrawerModal())
  }

  function handleConfirmButtonClick() {
    setCurrentStep(CONFIRM_SUBSCRIPTION_STEPS.SELECT_CONTACT)
  }

  function renderProductInfo({ name, value }) {
    return (
      <li className='product'>
        <strong>{name}</strong> - R${formatCurrenctyWithoutSignal(value)}/mês
      </li>
    )
  }

  function renderProductsInfo() {
    return <ul className='product-list'>{cart.map(renderProductInfo)}</ul>
  }

  function renderProductsTotalValue() {
    if (!isMultipleProducts) return ''

    return (
      <p className='total-value'>
        Valor total: <strong>R${formatCurrenctyWithoutSignal(totalValue)}</strong>/mês
        <br />
        <span className='caption'>(cobrança mensal na sua fatura)</span>
      </p>
    )
  }

  function renderDescription() {
    return <p className='description'>Ao continuar, você estará assinando:</p>
  }

  return (
    <div className='store-confirmation-info-container'>
      <h3 className='title'>Revisão de assinatura</h3>
      {renderDescription()}
      {renderProductsInfo()}
      {renderProductsTotalValue()}
      <a href={STORE_CONFIRMATION_TERM_FILE_URL} className='link' target='_blank' rel='noreferrer'>
        Consultar Termo de Adesão
      </a>
      <div className='disclaimer'>
        <STATICS.ROUNDED_LOCK_CLOSED className='icon' />
        <p className='description'>
          Ao continuar, você está de acordo com o Termo de Adesão. Em seguida, enviaremos um código
          para o telefone e e-mail cadastrados para validar sua contratação.
        </p>
      </div>
      <ActionContainer
        onConfirm={handleConfirmButtonClick}
        onBack={handleBackButtonClick}
        labelConfirm='Continuar e receber código'
        isLoading={isLoading}
      />
    </div>
  )
}
